import { type CognitoConfig as GQLItem } from '../generated/graphql';
import { take } from '../util';

export type CognitoConfig = {
  region?: string;
  clientId?: string;
};

export const fromGql = (item: GQLItem): CognitoConfig =>
  take(item, 'region', 'clientId') as CognitoConfig;
